// Copyright (c) Ping. All rights reserved.

import React from 'react';
import {
  StyleSheet,
  Text,
  type TextStyle,
  View,
  type ViewStyle,
} from 'react-native';
import { useColorScheme } from '../../foundations/colorScheme';
import { createTheme } from '../../design-system/theme';
import { activityStrings } from './strings';
import type { ActivityKind } from './types';

export interface ActivityEmptyStateProps {
  readonly filter: ActivityKind;
}

export const ActivityEmptyState = React.memo<ActivityEmptyStateProps>(({ filter }) => {
  const scheme = useColorScheme();
  const theme = createTheme(scheme === 'dark' ? 'dark' : 'light');

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.surface.primary }]}>
      <Text style={[styles.title, { color: theme.colors.text.primary }]}>
        {activityStrings.emptyTitle(filter)}
      </Text>
      <Text style={[styles.body, { color: theme.colors.text.secondary }]}>
        {activityStrings.emptyBody}
      </Text>
    </View>
  );
});

ActivityEmptyState.displayName = 'ActivityEmptyState';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  } satisfies ViewStyle,
  title: {
    fontSize: 17,
    fontWeight: '600',
    marginBottom: 6,
    textAlign: 'center',
  } satisfies TextStyle,
  body: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
    maxWidth: 320,
  } satisfies TextStyle,
});
